const StatusMessage = ({ translationMap }) => {
  return (
    <section className="w-100 clearfix" id="SmartResgistrationSection">
    <div className="SmartResgistrationSection">
        <div className="inner_alert_box inner_alert_box2">
            <div className="AlertInnerBox AlertInnerBox2 YellowAlertInnerBox alert alert-dismissible fade show">
                <div className="Icon_box">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                    <a href="javascript:void(0);">
                        <span className="material-symbols-outlined">
                            warning
                        </span>
                    </a>
                </div>
                <div className="alert_text">
                    <h6>
                        {translationMap?.ticketCannotBeGenerated}
                    </h6>
                    <p className="number_txt">
                        {translationMap?.ticketCannotBeGeneratedText}
                    </p>
                </div>
            </div>
        </div>
    </div>
    </section>);

};


export default StatusMessage;